<div>
  <div class="icon">
    <mat-icon>restore</mat-icon>
  </div>
  <div class="description">
    <strong>Aktify Reengagement</strong>
    <span>Aktify returned {{ activity.borrowerName }} to Lendio for reengagement</span>
  </div>
</div>
